import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Button, Card, CardBody, Col, Row } from 'reactstrap';
import ViewContainer from '../layout/ViewContainer';

class DatabaseMenuPage extends React.Component<RouteComponentProps & LocalizeContextProps> {

    public render() {
        const t = this.props.translate;
        return (
            <ViewContainer className="menu-view" >
                <h1 className="title">{t('database.menu.header.database')}</h1>
                <Row>
                    <Col xs={12} sm={6} md={4}>
                        <Card>
                            <CardBody>
                                <h3>{t('database.menu.text.importXML')}</h3>
                                <Button
                                    onClick={() => {
                                        this.props.history.push(`/database/import`);
                                    }}
                                    color="primary"
                                    className="float-right"
                                >
                                    {t('database.menu.button.go')} <FontAwesomeIcon className="ml-2" icon={['fal', 'arrow-right']} />
                                </Button>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </ViewContainer>
        );
    }
}

export default withLocalize(withRouter(DatabaseMenuPage));
